import React, {memo} from 'react';
import {twMerge} from 'tailwind-merge';

/**
 * DropdownMenuSeparator - Visual separator between groups inside a DropdownMenuContent.
 *
 * @typedef {Object} DropdownMenuSeparatorProps
 * @property {string} [className] - Additional CSS classes
 */
const DropdownMenuSeparator = memo(({className, ...props}) => {
	return (
		<div
			role="separator"
			className={twMerge('my-1 h-px bg-gray-100 dark:bg-gray-800', className)}
			{...props}
		/>
	);
});

DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';

export default DropdownMenuSeparator;
